// extracted by mini-css-extract-plugin
export default {"container":"faqpage_container__1NdQh","title":"faqpage_title__esH7K","main":"faqpage_main__KsMTB","section":"faqpage_section__u4xC-","footer":"faqpage_footer__hy8Gz"};